<ng-container>
  <ng-content></ng-content>
</ng-container>

<ng-container *ngIf="control && (control.dirty || control.touched)">
  <div class="invalid-feedback" *ngIf="control.errors?.required">
    Value is required
  </div>

  <div class="invalid-feedback" *ngIf="control.errors?.email">
    Invalid email format
  </div>

  <div class="invalid-feedback" *ngIf="control.errors?.minlength">
    Value must be {{ control.errors.minlength.requiredLength }} character
    length.
  </div>

  <div class="invalid-feedback" *ngIf="control.errors?.maxlength">
    Value must be at most
    {{ control.errors.maxlength.requiredLength }} characters length.
  </div>

  <div class="invalid-feedback" *ngIf="control.errors?.min">
    Value must be more then {{ control.errors.min.min }}.
  </div>

  <div class="invalid-feedback" *ngIf="control.errors?.max">
    Value must be at most {{ control.errors.max.max }}.
  </div>

  <div class="invalid-feedback" *ngIf="control.errors?.pattern">
    Invalid format
  </div>
</ng-container>
